module.exports = __webpack_public_path__ + "6a86a5698440c7b989c4ea23ec883d93.svg";